import { useFormContext } from 'react-hook-form';
import { FormLabel } from './ui/form';
import { FormControl, FormField } from './ui/form';
import { FormItem } from './ui/form';
import { Checkbox } from './ui/checkbox';
import { cn } from '@/shared/utils/styling';

type Props = Omit<React.ComponentProps<typeof FormField>, 'render'> & {
  name: string;
  label: string | React.ReactNode;
  hasError?: boolean;
  className?: string;
  checkboxClassName?: string;
};

const FormFieldCheckbox = ({
  name,
  label,
  hasError,
  className,
  checkboxClassName,
  ...props
}: Props) => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem
          className={cn('flex flex-row items-start gap-[1.6rem]', className)}>
          <FormControl>
            <Checkbox
              disabled={false}
              checked={Boolean(field.value)}
              onCheckedChange={field.onChange}
              className={cn(
                hasError ? 'checkbox-error' : '',
                checkboxClassName
              )}
            />
          </FormControl>
          <FormLabel className="p4 flex-1 min-w-0">{label}</FormLabel>
        </FormItem>
      )}
      {...props}
    />
  );
};

export { FormFieldCheckbox };
